export const splitIntoChunks = (str: string, chunkSize: number): string[] => {
  const chunks = [];
  for (let i = 0; i < str.length; i += chunkSize) {
    const chunk = str.substring(i, i + chunkSize);
    chunks.push(chunk);
  }
  return chunks;
}